import config from '../../config/config';

import getRequest from './base/get';

interface QueryParameters {
  [key: string]: any;
}

export default {
  /**
   * Fetch devices API
   * @param query
   */
  getConnectorCount: () =>
    getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-connectors`),
  /**
   * Fetch devices API
   * @param query
   */
  getStationCount: () =>
    getRequest(`${config.commonApiUrl}api/facility/v1/charging-station/total-charging-stations`),
  /**
   * Fetch devices API
   * @param query
   */
  getChargingPointCount: () =>
    getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-charging-points`),
  /**
   * Fetch devices API
   * @param query
   */
  getDefectCount: () =>
    getRequest(`${config.commonApiUrl}api/facility/v1/charging-point/total-faulted-connectors`),
  /**
   * Fetch devices API
   * @param query
   */
  getStationMap: () =>
    getRequest(`${config.commonApiUrl}api/facility/v1/charging-station/charging-stations-map`),
  /**
   * Fetch devices API
   * @param query
   */
  getStationDetails: (id: string) =>
    getRequest(
      `${config.commonApiUrl}api/facility/v1/charging-station/charging-stations-map/${id}`,
    ),
  /**
   * Fetch devices API
   * @param query
   */
  getEndConsumersMonthWise: () =>
    getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/end-consumers-month-wise`,
    ),
  /**
   * Fetch devices API
   * @param query
   */
  getPowerConsumedMonthWise: () =>
    getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/power-consumed-month-wise`,
    ),
  /**
   * Fetch revenue API
   * @param query
   */
  getRevenueMonthWise: () =>
    getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/power-consumed-month-wise`,
    ),
  /**
   * Fetch devices API
   * @param query
   */
  getPowerConsumedReport: (query: QueryParameters) =>
    getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/power-consumption-report`,
      { ...query },
    ),
  /**
   * Fetch devices API
   * @param query
   */
  getConnectorStatusReport: () =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/connector-status-report`),
  /**
   * Fetch devices API
   * @param query
   */
  getDeviceStatusReport: () =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/device-status-report`),
  /**
   * Fetch devices API
   * @param query
   */
  getAlertsReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/alerts-report`, { ...query }),
  /**
   * Fetch devices API
   * @param query
   */
  getScheduleChargingReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/schedule-charging-report`, {
      ...query,
    }),
  /**
   * Fetch devices API
   * @param query
   */
  getStationPerformanceReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/station-performance-report`, {
      ...query,
    }),
  /**
   * Fetch devices API
   * @param query
   */
  getDeviceActiveIdleReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/device-active-idle-report`, {
      ...query,
    }),
  /**
   * Fetch devices API
   * @param query
   */
  getDeviceUtilizationReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/device-utilization-report`, {
      ...query,
    }),
};
